module.exports = __webpack_public_path__ + "static/img/consumer-h5.127902e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/consumer-h5.png
// module id = s2HP
// module chunks = 34